import React from 'react';
import LookupItemService from '../../../../../Services/LookupItemService';
import { MultiSelect } from 'react-multi-select-component';
import ErrorMessage from '../../../../ErrorMessage';
import LoadingIcon from '../../../../LoadingIcon';
import DepartmentEnum from '../../../../../Enums/DepartmentEnum';

export default class FreelancerDepartmentMultiChoice extends React.Component {
  static defaultProps = {
    className: '',
    fieldName: '',
    filterCleared: false,
    showSelectFilterAt: 10,
    onChange: () => alert('FreelancerDepartmentMultiChoice OnChange'),
    selected: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      selected: [],
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.populateListData();
    }
  }

  populateListData() {
    const validDepartment = [
      DepartmentEnum.RM.toString(),
      DepartmentEnum.KAM.toString(),
      DepartmentEnum.BD.toString(),
      DepartmentEnum.DQ.toString(),
      DepartmentEnum.IT.toString(),
      DepartmentEnum.BI.toString(),
      DepartmentEnum.Finance.toString(),
      DepartmentEnum.Marketing.toString(),
      DepartmentEnum.HR.toString(),
    ];

    LookupItemService.GetLookupItemListByLookupId(69)
      .then((result) => {
        const optValues = [];
        const selected = [];
        result.sort((a, b) => (a.text > b.text ? 1 : a.text < b.text ? -1 : 0));

        result.forEach((lookupItem) => {
          if (validDepartment.includes(lookupItem.value)) {
            optValues.push({
              label: lookupItem.text,
              value: lookupItem.value,
              disabled: false,
            });

            if (
              this.props.selected &&
              (this.props.selected.includes(lookupItem.value) ||
                this.props.selected.includes(lookupItem.value.toString()) ||
                this.props.selected.includes(parseInt(lookupItem.value)))
            ) {
              selected.push({
                label: lookupItem.text,
                value: lookupItem.value,
                disabled: false,
              });
            }
          }
        });

        this.setState({ itemList: optValues, loading: false, selected });
      })
      .catch(() => {
        this.setState({ itemList: [], loading: false });
        ErrorMessage.SetErrorMessage('FDMC55');
      });
  }

  multiSelectOnChange(selected) {
    this.setState({ selected: selected });
    this.props.onChange(
      this.props.fieldName,
      selected.map((i) => i.value)
    );
  }

  renderList() {
    return (
      <MultiSelect
        className='rmsc'
        options={this.state.itemList}
        value={this.state.selected}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render() {
    return (
      <div className='w-100'>
        <div className='text-center hover rounded arial'>
          {this.state.loading ? (
            <LoadingIcon
              loading={true}
              className='h6'
            />
          ) : (
            this.renderList()
          )}
        </div>
      </div>
    );
  }
}
